export const ARRIVALS = "arrivals"
export const DEPARTURES = "derpartures"
